/**
 * Локальная история расчётов матрицы (localStorage) при недоступности API.
 */

const MATRIX_HISTORY_LOCAL_KEY = 'matrix_history_local';

export interface LocalMatrixItem {
  id: string;
  name: string;
  birth_date: string;
  created_at: string;
}

export function getLocalMatrixHistory(): LocalMatrixItem[] {
  try {
    const raw = localStorage.getItem(MATRIX_HISTORY_LOCAL_KEY);
    if (!raw) return [];
    const list = JSON.parse(raw);
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function addToLocalMatrixHistory(name: string, birthDate: string): void {
  const list = getLocalMatrixHistory();
  const item: LocalMatrixItem = {
    id: `local_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
    name,
    birth_date: birthDate,
    created_at: new Date().toISOString(),
  };
  list.unshift(item);
  try {
    localStorage.setItem(MATRIX_HISTORY_LOCAL_KEY, JSON.stringify(list.slice(0, 50)));
  } catch (_) {}
}
